<template>
  <div>
        <p v-if="marker.infoText.ids && !marker.infoText.isShared"><br>
          ID/s: <strong v-for="(id, index) in marker.infoText.ids" :key="index">
            <b-link :to="{name: 'ShippingsEdit', params: {id}}" target="_blank">{{ id }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a><span v-if="(index + 1) < marker.infoText.ids.length">, </span>
          </strong>
        </p>
        <h6 v-else>
          <span v-translate><strong>Shared</strong> Shipment</span>
        </h6>
        <div v-html="marker.infoText.html"></div>
        <div v-if="marker.infoText.data.courier">
          <hr class="my-1">
          <user-card class="my-3" :user="marker.infoText.data.courier" :withMap="false" profilePictureSize="50px" :withTitles="false" />
        </div>
        <div>
          <div class="text-center">
            <b-button size="sm" variant="primary" @click="$root.$emit('data-selected', {...shipping, ...{cardType: 'shipping', normalize: true}})" v-translate>
              View Detail
            </b-button>
          </div>
        </div>
      </div>
</template>

<script>
import Vue from 'vue'
import ShippingCheckpointMicro from '@/components/Shippings/CheckpointMicro'

export default {
  name: 'ShippingVisit',
  props: {
    shipping: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      marker: { infoText: null },
      companyCountryConfig: null
    }
  },
  created() {
    this.companyCountryConfig = window.countries.find(x => x.iso_code === this.profile.company.country_iso_code).front_config
    this.marker.infoText = { ids: [this.shipping.id], type: 'gcm-shipping', html: this._createShippingInfoWindow(this.normalizeShipping(this.shipping)), data: this.shipping, isShared: this.shipping.isShared }
  },
  methods: {
    _createShippingInfoWindow(item) {
      let html = '<div class="mb-1">'
      html += new Vue({ ...ShippingCheckpointMicro, parent: this, propsData: { shipping: item, checkpoint: 'from', withCheckpointName: true, inline: true } }).$mount().$el.outerHTML
      html += '</div><div class="mb-1">'
      html += new Vue({ ...ShippingCheckpointMicro, parent: this, propsData: { shipping: item, checkpoint: 'to', withCheckpointName: true, inline: true } }).$mount().$el.outerHTML
      html += '</div>'
      if (item.commissionRaw !== 0) {
        html += '<p>' + this.$gettextInterpolate(this.$gettext('<strong>Profit</strong> %{commission}'), { commission: item.commission }, true) + '</p>'
      }
      return html
    },
    normalizeShipping(shipping, isShared = false) {
      const eventsIcons = shipping.events ? shipping.events.event_names : null
      return shipping.address_from && shipping.address_to
        ? {
            id: shipping.id,
            isShared: shipping.isShared,
            cardType: 'shipping',
            courier: shipping.courier || null,
            from_contact: shipping.from_contact,
            from_address: shipping.address_from.formatted_address,
            from_meta: shipping.from_meta,
            to_contact: shipping.to_contact,
            to_address: shipping.address_to.formatted_address,
            to_meta: shipping.to_meta,
            from_lat: shipping.address_from.lat,
            from_lng: shipping.address_from.lng,
            to_lat: shipping.address_to.lat,
            to_lng: shipping.address_to.lng,
            status: shipping.status,
            is_back_and_forth: shipping.is_back_and_forth,
            commission: !shipping.events ? Number.parseFloat(shipping.courier_commission).toLocaleString(this.companyCountryConfig.i18n.lang.replaceAll('_', '-'), { style: 'currency', currency: this.companyCountryConfig.i18n.currency }) : '<strike>' + Number.parseFloat(shipping.courier_commission).toLocaleString(this.companyCountryConfig.i18n.lang.replaceAll('_', '-'), { style: 'currency', currency: this.companyCountryConfig.i18n.currency }) + '</strike> ' + this.renderIcons(eventsIcons) + Number.parseFloat(shipping.events.total_commission).toLocaleString(this.companyCountryConfig.i18n.lang.replaceAll('_', '-'), { style: 'currency', currency: this.companyCountryConfig.i18n.currency }),
            commissionRaw: Number.parseInt(shipping.courier_commission),
            type: this.shippingTypesShared.find(x => x.value === shipping.shipping_type_id).text,
            size: this.shippingSizes.find(x => x.id === shipping.size_id)?.name || 'no-size',
            distance: this.baseData
              ? this.getDistance(this.baseData, {
                lat: shipping.address_from.lat,
                lng: shipping.address_from.lng
              })
              : null,
            total_distance: this.getDistance({
              lat: shipping.address_from.lat,
              lng: shipping.address_from.lng
            }, {
              lat: shipping.address_to.lat,
              lng: shipping.address_to.lng
            }),
            tags: shipping.tags,
            items: shipping.items && shipping.items.length > 0 ? shipping.items : [],
            threads: shipping.threads,
            meta: shipping.meta,
            shipping
          }
        : {}
    }
  }
}
</script>